import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDataFresh, getVehiclesData } from "../../state/selectors";
import {
  createSetDataFreshAction,
  createSetVehiclesDataAction
} from "../../actions/dataActions";
import useEditableTableTextCell from "../../hooks/useEditableTableTextCell";

export default function CourtesyCarRow({ value, index, onSave }) {
  const [editable, setEditable] = useState(false);
  const vehicles = useSelector(getVehiclesData);
  const dataFresh = useSelector(getDataFresh);
  const dispatch = useDispatch();

  const onChange = e => {
    let newVehicle = vehicles.results[index];
    newVehicle[e.target.name] = e.target.value;
    let newVehicles = { ...vehicles };
    newVehicles.results[index] = newVehicle;
    dispatch(createSetVehiclesDataAction(newVehicles));
  };



  return (
    <tr
      className="clickable"
      style={{ fontSize: 12 }}
      onClick={() => window.open(`/editvehicle/${value.id}`, "_self")}
      key={value.id}
    >
      <td>{value.department ? value.department.name : ""}</td>
      <td>{value.registration}</td>
      <td>{value.make ? value.make.name : ""}</td>
      <td>{value.model ? value.model.name : ""}</td>
      {useEditableTableTextCell({
        propName: "location",
        value: value.location,
        onChange,
        onSave: (e) => onSave(e, value, setEditable),
        editable,
        setEditable,
        inlineEdit: true
      })}
    </tr>
  );
}
